module.exports = __webpack_public_path__ + "static/media/baur.bdc3f166.png";